import config from "@/config"
import http from "@/utils/request"

export default {
    list: {
		url: `${config.API_URL}/noticeType/`,
		name: "查询通知类型",
		get: async function(data){
			return await http.get(this.url, data);
		}
	}
}
